<div class="edit-client">
  @if (!hideCrumbs) {
    <rn-progress-tabs [tabs]="statusTabs" [selectedTabId]="activeTabId()" [clickable]="true" (tabClicked)="tabClicked($event)"></rn-progress-tabs>
  }
  @if (!hideCrumbs && subnavLinks) {
    <rn-breadcrumbs [links]="subnavLinks"></rn-breadcrumbs>
  }
  <router-outlet></router-outlet>
</div>

<message-dialog></message-dialog>
